import Vue from 'vue'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    suppliers: [],
    loading: false,
    error: null,
  },
  getters: {
    suppliers: state => state.suppliers,
    loading: state => state.loading,
    error: state => state.error,
  },
  mutations: {
    SET_SUPPLIERS(state, payload) {
      state.suppliers = payload
    },
    ADD_SUPPLIER(state, payload) {
      state.suppliers.unshift(payload)
    },
    UPDATE_SUPPLIER(state, payload) {
      const index = state.suppliers.findIndex(
        supplier => supplier.id === payload.id,
      )
      Vue.set(state.suppliers, index, payload)
    },
    DELETE_SUPPLIER(state, payload) {
      const index = state.suppliers.findIndex(
        supplier => supplier.id === payload,
      )
      state.suppliers.splice(index, 1)
    },
    SET_LOADING: (state, payload) => {
      state.loading = payload
    },
    SET_ERROR: (state, payload) => {
      state.error = payload
    },
    // eslint-disable-next-line no-return-assign
    CLEAR_ERROR: state => (state.error = null),
  },
  actions: {
    async getSuppliers({ commit }) {
      try {
        commit('SET_LOADING', true)
        const { data } = await axiosIns.get('/suppliers/')
        commit('SET_SUPPLIERS', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
      }
    },
    async addSupplier({ commit }, payload) {
      try {
        commit('CLEAR_ERROR')
        commit('SET_LOADING', true)
        const { data } = await axiosIns.post('/suppliers/create/', payload)
        commit('ADD_SUPPLIER', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
    async updateSupplier({ commit }, payload) {
      try {
        const { data } = await axiosIns.put(
          `/suppliers/update/${payload.id}/`,
          payload,
        )
        commit('UPDATE_SUPPLIER', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
    async deleteSupplier({ commit }, payload) {
      try {
        await axiosIns.delete(`/suppliers/delete/${payload}`)
        commit('DELETE_SUPPLIER', payload)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
  },
}
